<template>
    <div id="app">
        <!-- 中文版头部和底部 -->
        <template v-if="!isEnglish">
            <headers :tabactivetan="tabactivetan" />
            <router-view></router-view>
            <footers />
        </template>

        <!-- 英文版头部和底部 -->
        <template v-else>
            <enheaders :tabactivetan="tabactivetan" />
            <router-view></router-view>
            <enfooters />
        </template>

        <div class="cssloader" v-if="showpase == 0">
            <div class="circle-loader"></div>
            <h4 class="cssloaderlt">loading</h4>
        </div>
    </div>
</template>
<script> 
import headers from '@/components/headers';
import footers from "@/components/footer";
import enheaders from '@/components/enheader';
import enfooters from "@/components/enfooter";
export default {
    name: 'App',
    components: {
        headers,
        footers,
        enheaders,
        enfooters,
    },
    data() {
        return {
            showpase: 0,
            tabactivetan: null,
        };
    },
    computed: {
        isEnglish() {
            return this.$route.path.startsWith('/en');
        }
    },
    watch: {
    },
    created() {
        this.handleResize()
        this.$router.afterEach((to, from) => {
            if (to) {
                this.showpase = 1; // 可根据实际需求调整逻辑
            }
            const currentRoute = to.path;
            
            // 判断是中文还是英文路由
            if (currentRoute.startsWith('/en')) {
                // 英文路由：提取路径部分
                const enRoutes = ['/en/index', '/en/products', '/en/about', '/en/businessmovement', '/en/hiring', '/en/contact'];
                const index = enRoutes.indexOf(currentRoute);
                this.tabactivetan = index >= 0 ? index : 0;
            } else {
                // 中文路由
                const list = this.$router.options.routes.map(rel => rel.path);
                const his = [list[1], list[2], list[3], list[4], list[5], list[6]];
                his.forEach((path, index) => {
                    if (path === currentRoute) {
                        this.tabactivetan = index;
                    }
                });
            }
        });
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        handleResize() {
            const baseSize = 100; // 设计稿宽度的1/100
            const baseWidth = 1920; // PC端设计稿的宽度
            const mobileBaseWidth = 750; // 移动端设计稿的宽度
            const clientWidth = document.documentElement.clientWidth || window.innerWidth;
            // 判断当前是移动端还是PC端
            let rem;
            if (clientWidth <= mobileBaseWidth) {
                // 移动端：设置最小宽度限制（比如 375）
                const minWidth = 300;
                const effectiveWidth = Math.max(clientWidth, minWidth);
                console.log(effectiveWidth);

                rem = (effectiveWidth / mobileBaseWidth) * baseSize;
                this.$store.commit('user/SET_specification', "h5");
                // alert(clientWidth)
            } else {
                // PC端，使用设计稿宽度1920px计算
                rem = (clientWidth / baseWidth) * baseSize;
                this.$store.commit('user/SET_specification', "pc")
            }
            document.documentElement.style.fontSize = `${rem}px`;

            // console.log(document.documentElement.style.fontSize, 'document.documentElement.style.fontSize');

            /*
            this.$nextTick(() => {
              // 滚动到之前的位置
              window.scrollTo(0, 1);
            });
            */
        }
        ,
    }
}
</script>
<style lang="scss">
@import "../public/font-css/main.css";

@function rem($px) {
    $base-font-size: 100; // 根据设计稿的基准字体大小设置
    @return $px / $base-font-size * 1rem;
}

.card_img {
    img {
        width: 0.9rem;
        height: 0.9rem;
    }
}

@import url("https://fonts.googleapis.com/css?family=Roboto:100");
#app {
    position: relative;
    background: #00012d;
}

.cssloader {
    background: #00012d; /* 背景色 */
    width: 100%; /* 宽度 100% 覆盖整个屏幕 */
    height: 100vh; /* 高度 100vh 覆盖整个视口高度 */
    position: fixed; /* 使用 fixed 定位，使其覆盖整个屏幕 */
    top: 0; /* 顶部对齐视口 */
    left: 0; /* 左侧对齐视口 */
    z-index: 9999; /* 确保该元素位于最上层 */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.cssloaderlt {
    color: #fff;
    // font-family: "SOURCEHANSANSCN-NORMAL";
    margin: 0.1rem auto;
    text-align: center;
    font-weight: 100;
    letter-spacing: 0.03rem;
}
.circle-loader {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(255, 255, 255, 0.2);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
